export default __webpack_public_path__ + "static/media/building.50dce998.jpg";